// TODO: Rename to FilterType
export enum RegrelloFormFieldFilterType {
  CHECKBOX = "checkbox",
  DATE = "date",
  DATE_STRING = "dateString",
  DIVIDER = "divider",
  MULTI_SELECT = "multi-select",
  NUMBER = "number",
  PARTY_SELECT = "party-select",
  SELECT = "select",
  TAG_SELECT = "tag-select",
  TEXT = "text",
}

export interface FilterTypeUnionBase {
  label: string;
  type: RegrelloFormFieldFilterType;
}
